import { ClientEditModel } from "./../../../../../node_modules/@playcharge/common/models/backend/clients/client-edit-model";
import { OfferSourceType } from "./../../../../../node_modules/@playcharge/common/models/backend/offers/offer-source-type";
import { ChangeDetectionStrategy, Component, effect, inject, signal } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { ToastrService } from "ngx-toastr";
import { CommonModule } from "@angular/common";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { ClientsStore } from "../../../stores/clients/client.store";
import { ClientViewModel } from "@playcharge/common/models/backend/clients/client-view-model";
import { EditClientDialogComponent } from "../edit-client-dialog/edit-client-dialog.component";
import { Nullable } from "@playcharge/common/models/backend/nullable";
import { HttpErrorResponse } from "@angular/common/http";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";

@Component({
    selector: "app-clients",
    standalone: true,
    imports: [
        CommonModule,
        MatTableModule,
        MatIcon,
        MatButton,
        MatMenuTrigger,
        MatMenu,
        MatMenuItem,
    ],
    templateUrl: "./clients.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientsComponent {
    private _matDialog = inject(MatDialog);
    private _toastrService: ToastrService = inject(ToastrService);

    public clientsStore = inject(ClientsStore);

    public displayedColumns = signal(["title", "sourceType", "actions"]);

    public dataSource: MatTableDataSource<ClientViewModel> =
        new MatTableDataSource<ClientViewModel>();

    public OfferSourceType = OfferSourceType;

    constructor() {
        effect(() => {
            this.dataSource.data = this.clientsStore.entities();
        });
    }

    public openEditClient(client?: ClientViewModel) {
        this._matDialog
            .open<EditClientDialogComponent, Nullable<ClientViewModel>, ClientEditModel>(
                EditClientDialogComponent,
                {
                    data: client,
                },
            )
            .afterClosed()
            .subscribe((model) => {
                if (model) {
                    const isEditMode = !!client;

                    const request = {
                        model,
                        next: () => this._toastrService.success("Done"),
                        error: (error: HttpErrorResponse) =>
                            this._toastrService.error(
                                error?.error?.description ?? "Internal Error",
                            ),
                    };

                    if (isEditMode) {
                        this.clientsStore.updateClient(request);
                    } else {
                        this.clientsStore.createClient(request);
                    }
                }
            });
    }
}
